import React, { useEffect } from "react";
import "./styles.css";

export const handler = ({ inputs, mechanic }) => {
  const {
    format,
    width,
    height,
    title,
    event1,
    event2,
    event3,
    event4,
    event5,
    event6,
    titleAlign,
    titlePosition,
    textAlign,
    gap
  } = inputs;

  // Calculate dimensions based on format
  const formatDimensions = {
    vertical: { width: 1080, height: 1350 },
    square: { width: 1080, height: 1080 },
    landscape: { width: 1080, height: 566 },
    story: { width: 1080, height: 1920 },
    custom: { width: width, height: height }
  };
  
  const dimensions = formatDimensions[format];
  const finalWidth = dimensions.width;
  const finalHeight = dimensions.height;

  // Collect manually entered list items and filter empty ones
  const events = [event1, event2, event3, event4, event5, event6]
    .filter(e => e && e.trim());

  // Build list text
  const displayText = events.join('\n');

  // Generate random rotations on each render
  const finalTitleRotation = parseFloat((Math.random() * 20 - 10).toFixed(1));
  const finalTextRotation = parseFloat((Math.random() * 20 - 10).toFixed(1));

  // Convert alignment to flexbox position
  const getAlignSelf = (align) => {
    if (align === "left") return "flex-start";
    if (align === "right") return "flex-end";
    return "center";
  };

  useEffect(() => {
    mechanic.done();
  }, []);

  return (
    <div
      className="event-layout-container"
      style={{
        width: `${finalWidth}px`,
        height: `${finalHeight}px`,
        backgroundColor: "#ffffff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: `${gap}px`,
        padding: "60px 100px",
        boxSizing: "border-box",
        position: "relative",
        overflow: "hidden"
      }}
    >
      <h1
        className="rotated-title"
        style={{
          color: "#6691cb",
          fontSize: "54px",
          fontWeight: 500,
          fontFamily: "Figtree, sans-serif",
          transform: `rotate(${finalTitleRotation}deg)`,
          margin: 0,
          textAlign: titleAlign,
          textTransform: "lowercase",
          alignSelf: getAlignSelf(titlePosition)
        }}
      >
        {title}
      </h1>
      
      <p
        className="rotated-text"
        style={{
          color: "#6691cb",
          fontSize: "32px",
          fontWeight: 400,
          fontFamily: "Figtree, sans-serif",
          transform: `rotate(${finalTextRotation}deg)`,
          margin: 0,
          textAlign: "left",
          // maxWidth: "100%",
          lineHeight: 1.6,
          whiteSpace: "pre-wrap",
          alignSelf: getAlignSelf(textAlign)
        }}
      >
        {displayText}
      </p>
    </div>
  );
};

export const inputs = {
  format: {
    type: "text",
    default: "vertical",
    options: ["vertical", "square", "landscape", "story", "custom"],
    label: "Format"
  },
  width: {
    type: "number",
    default: 1080,
    label: "Width",
    editable: (inputs) => inputs.format === "custom"
  },
  height: {
    type: "number",
    default: 1350,
    label: "Height",
    editable: (inputs) => inputs.format === "custom"
  },
  title: {
    type: "text",
    default: "Lorem ipsum dolor sit amet consectetur adipiscing"
  },
  titleAlign: {
    type: "text",
    default: "center",
    options: ["left", "center", "right"],
    label: "Title Alignment"
  },
  titlePosition: {
    type: "text",
    default: "center",
    options: ["left", "center", "right"],
    label: "Title Position"
  },
  event1: {
    type: "text",
    default: "",
    label: "Event 1"
  },
  event2: {
    type: "text",
    default: "",
    label: "Event 2"
  },
  event3: {
    type: "text",
    default: "",
    label: "Event 3"
  },
  event4: {
    type: "text",
    default: "",
    label: "Event 4"
  },
  event5: {
    type: "text",
    default: "",
    label: "Event 5"
  },
  event6: {
    type: "text",
    default: "",
    label: "Event 6"
  },
  textAlign: {
    type: "text",
    default: "center",
    options: ["left", "center", "right"],
    label: "Text Position"
  },
  gap: {
    type: "number",
    default: 650,
    min: 0,
    max: 1100,
    step: 10,
    slider: true,
    label: "Vertical Gap (px)"
  }
};

// export const presets = {
//   vertical: {
//     format: "vertical",
//     gap: 650
//   },
//   square: {
//     format: "square",
//     gap: 550
//   },
//   landscape: {
//     format: "landscape",
//     gap: 250
//   },
//   story: {
//     format: "story",
//     gap: 800
//   }
// };

export const settings = {
  engine: require("@mechanic-design/engine-react"),
  name: "List Layout",
  persistRandomOnExport: true,
  hidePresets: true,
  hideAutoRefresh: true,
  ignoreStyles: false,  // Inject CSS into SVG for proper font rendering
  hideScaleToFit: true  // Ensure content scales to fit the defined dimensions
};
